// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget__header>h1.center{text-align:center}.widget__header>h1.right{text-align:right}.widget__header>h1.xl{font-size:32px;line-height:1.3}.widget__header>h1.xxl{font-size:36px;line-height:1.3}", ""]);
// Exports
module.exports = exports;
